<template>
  <div>
    <!-- Timestamps Store -->
  </div>
</template>

<script>
export default {
  name:'SyncTimestampsStore',
  props:['storeNames', 'mainStore'],
  inject: ['page'],
  computed:{
    store(){return this.page.$refs[this.storeName]},
    // timestamps(){ return this.store.timestamps},
  },
  data () { return { 
      timestamps:{
          dateKey:'week',
          from: undefined,
          to: undefined,
      },
    }
  },
  watch:{
    timestamps: {
      deep: true,
      handler(){
        (this.storeNames || []).forEach(store=>{
          if (this.page.$refs[store] && this.page.$refs[store].timestamps){
            this.page.$refs[store].timestamps.from = this.timestamps.from
            this.page.$refs[store].timestamps.to = this.timestamps.to
            this.page.$refs[store].timestamps.dateKey = this.timestamps.dateKey
          }
        })
        this.loadData();
      }
    }
  },
  methods:{
    loadData(){ 
      // console.log('SyncTimestampsStore - loadData');
      // console.log('SyncTimestampsStore - loadData', this.storeNames);
      (this.storeNames || []).forEach(store=>{
        // console.log(`SyncTimestampsStore - ${store} - loadData1`);
        if (this.page.$refs[store] && this.page.$refs[store].loadData){
          console.log(`SyncTimestampsStore - ${store} - loadData2`, this.timestamps.from, this.timestamps.to);
          this.page.$refs[store].loadData()
        }
      })
    }
  },
}
</script>